class UserQueryKeys {
  constructor(private prefix: string) {}

  getCurrentUser() {
    return [this.prefix, 'current'];
  }

  getUserPreferences() {
    return [this.prefix, 'preferences'];
  }

  getFrontendSyncConfiguration() {
    return [this.prefix, 'frontend-sync-configuration'];
  }

  getMailConfiguration() {
    return [this.prefix, 'mail-configuration'];
  }
}

export default UserQueryKeys;
